import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";

export default function Themhanghoatonghop() {
  const [thangnam, setThangnam] = React.useState(dayjs());
  const [sanluonghhvanchuyen, setSanluonghhvanchuyen] = React.useState(0);
  const [sanluonghhluanchuyen, setSanluonghhluanchuyen] = React.useState(0);
  const [sovoicungky, setSovoicungky] = React.useState(0);
  const [ghichu, setGhichu] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [disableBT, setDisableBT] = React.useState(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  const insertbaocao = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url = Config.backend + "/api/Donvi/themslthduongthuyhh";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        thang: thang,
        sanluonghhvanchuyen: sanluonghhvanchuyen,
        sanluonghhluanchuyen: sanluonghhluanchuyen,
        sovoicungky: sovoicungky,
        ghichu: ghichu,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
        } else showNotification1();
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Tháng báo cáo"
                  value={thangnam}
                  format="MM/YYYY"
                  onChange={(newValue) => {
                    setDisableBT(false);
                    setThangnam(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <NumericFormat
                label="Sản lượng hàng hóa vận chuyển"
                variant="outlined"
                size="small"
                value={sanluonghhvanchuyen}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSanluonghhvanchuyen(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <NumericFormat
                label="Sản lượng hàng hóa luân chuyển"
                variant="outlined"
                size="small"
                value={sanluonghhluanchuyen}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSanluonghhluanchuyen(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <NumericFormat
                label="So với cùng kỳ (%)"
                variant="outlined"
                size="small"
                value={sovoicungky}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSovoicungky(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Ghi chú báo cáo"
                variant="outlined"
                size="small"
                value={ghichu}
                onChange={(event) => {
                  setGhichu(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "30px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          disabled={disableBT}
          onClick={insertbaocao}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
